"use client";
import { useEffect, useState } from "react";
import { getCookie } from "@directv-digital/dds.services.cookie-service";

type RecognizedUserData = { accountType: "stream" | "satellite" };

type UseUserRecognitionResult = {
  clientSideIsUserAuthenticated: boolean;
  clientSideRecognizedUserData: RecognizedUserData | null;
  clientSideIsRecognized: boolean;
};

type UseUserRecognitionOptions = {
  initialRecognizedUserData?: RecognizedUserData | null;
  isUserAuthenticated?: boolean;
};

export function useUserRecognition(
  options: UseUserRecognitionOptions = {}
): UseUserRecognitionResult {
  const [clientSideIsUserAuthenticated, setClientSideIsUserAuthenticated] = useState(
    options.isUserAuthenticated
  );
  const [clientSideRecognizedUserData, setClientSideRecognizedUserData] =
    useState<RecognizedUserData | null>(
      options?.initialRecognizedUserData || null
    );
  const [clientSideIsRecognized, setClientSideIsRecognized] = useState(
    Boolean(options.initialRecognizedUserData)
  );

  useEffect(() => {
    const cAuthNStateCookie = getCookie("cAuthNState");
    const recogmeCookie = getCookie("recogme");
    const accTypeInCtxCookie = getCookie("accTypeInCtx");
    const authenticated =
      !!cAuthNStateCookie && cAuthNStateCookie !== "en" && !!accTypeInCtxCookie;
    const recognized =
      !!recogmeCookie &&
      recogmeCookie.trim() !== "" &&
      !!accTypeInCtxCookie &&
      accTypeInCtxCookie.trim() !== "";

    console.log(
      `cAuthNState: ${cAuthNStateCookie}\n`,
      `recogme: ${recogmeCookie}\n`,
      `acc: ${accTypeInCtxCookie}\n`,
      `auth: ${authenticated}\n`,
      `rec: ${recognized}`
    );

    if (authenticated) {
      setClientSideIsUserAuthenticated(true);
    }

    setClientSideIsRecognized(!authenticated && Boolean(recognized));

    if ((authenticated || recognized) && !options.initialRecognizedUserData) {
      if (
        ["ATTTV", "ATTTV_NONVIDEO", "ATTTV_ENABLER"].includes(
          accTypeInCtxCookie!
        )
      ) {
        setClientSideRecognizedUserData({ accountType: "stream" });
      } else if (["STMS", "NEWCO", "ENABLER"].includes(accTypeInCtxCookie!)) {
        setClientSideRecognizedUserData({ accountType: "satellite" });
      }
    }
  }, [options.initialRecognizedUserData]);

  return {
    clientSideIsUserAuthenticated,
    clientSideRecognizedUserData,
    clientSideIsRecognized
  };
}

export default useUserRecognition;
